import { getComponentCssUrl, getGlobalCssUrl } from '../Global/loadDependency'


// Lazy template creation to avoid calling getCdnUrl at module load time
function createSearchBoxTemplate() {
  const t = document.createElement('template')
  t.innerHTML = `
<link href="${getGlobalCssUrl()}" rel="stylesheet" />
<link href="${getComponentCssUrl('SearchBox--wc.css')}" rel="stylesheet" />

`
  return t;
}

const getTemplateSearchBoxStyles = () => createSearchBoxTemplate();
export { getTemplateSearchBoxStyles };